// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorFallback_message__3xu66","headline":"ErrorFallback_headline__3GkuG","subHeadline":"ErrorFallback_subHeadline__3SgtM"};